import pino from 'pino';
import { pinoConfig } from '@/config/logger.config';
import { defineNuxtPlugin } from '#imports';

// Create a pino logger instance for browser
export default defineNuxtPlugin(() => {
  const logger = pino(pinoConfig);

  return {
    provide: {
      logger,
    },
  };
});
